import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import Check from "../../../Assets/Svgs/Check";

function FormSubmit({ open, handleClose }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        ".css-10d30g3-MuiPaper-root-MuiDialog-paper": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
          flexWrap: "wrap",
          width: window.innerWidth > 425 ? "80%" : "auto",
        },
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(50deg, #00b8d9 0, #0077d9 100%)",
          height: "20vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {" "}
        <Check />{" "}
      </Box>
      <DialogTitle
        sx={{
          textAlign: "center",
          color: "linear-gradient(50deg, #00b8d9 0, #0077d9 100%)",
        }}
      >
        Success
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center" }}>
        <Typography>
          Congratulations, your form has been submitted successfully!
        </Typography>
        <Button
          onClick={() => handleClose(false)}
          variant="contained"
          sx={{
            mt: 2,
            background: "linear-gradient(50deg, #00b8d9 0, #0077d9 100%)",
            color: "white",
            width: "30%",
            padding: "12px",
          }}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
}
export default FormSubmit;
